// extracted by mini-css-extract-plugin
export default {"main":"app_main__rmRZz"};